<script setup lang="ts">
  import { computed } from 'vue';
  import type { FormElement, FixedTextProperties } from '../../../model/form.types';
  import { useElementContainerStyles } from '../../../model/useElementContainerStyles';

  interface Props {
    element: FormElement & { properties: FixedTextProperties };
  }

  const props = defineProps<Props>();

  const textAlignClass = computed(() => {
    const alignments = {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
    };
    return (
      alignments[(props.element.properties.textAlign as keyof typeof alignments) || 'left'] ||
      'text-left'
    );
  });

  const { containerStyles: elementStyles } = useElementContainerStyles(
    computed(() => props.element.properties),
    'FIXED_TEXT'
  );

  const singleLineContent = computed(() => {
    return (props.element.properties.content ?? '').replace(/[\r\n]+/g, ' ').trim();
  });
</script>

<template>
  <div
    :class="['fixed-text-element', textAlignClass]"
    :style="elementStyles"
  >
    {{ singleLineContent }}
  </div>
</template>

<style scoped>
  .fixed-text-element {
    font-family: var(--font-base);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
